// @flow
import PageNodeHeader from 'components/page/PageNodeHeader';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/page/PageNodeHeader';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      title: state.pageNodeState.pageNode.title,
      slug_parent: state.pageNodeState.pageNode.slug_parent,
      slug: state.pageNodeState.pageNode.slug,
      titleParent: state.pageNodeState.pageNode.titleParent,
      description: state.pageNodeState.pageNode.description,
      featured_media: state.pageNodeState.pageNode.featured_media,
      templateDetail: state.pageDetailState.template,
      meta_description: state.pageNodeState.pageNode.meta_description,
      meta_title: state.pageNodeState.pageNode.meta_title
    })
  )(PageNodeHeader)
);
